<script>

	let hexa = "0123456789ABCDEF".split("")
	
	let r = 8
	let g = 8
	let b = 8

	let collection = []
	let selectedColor = '#000'
	let complementColor = "#FFF"
	
	function changeColor(color){
		if( color.match(/undefined/g) )
			return

		selectedColor = color
		complementColor = "#"  + hexa[ hexa.length - hexa.indexOf(color.charAt(1))  - 1 ] 
		+ hexa[ hexa.length - hexa.indexOf(color.charAt(2)) - 1] 
		+ hexa[ hexa.length - hexa.indexOf(color.charAt(3)) - 1] 

//		console.log( hexa.indexOf(color.charAt(1)), " ", hexa.indexOf(color.charAt(2)), " ", hexa.indexOf(color.charAt(3)) )
	}

	function rangeChange()
	{
		selectedColor = "#"+ hexa[r] + hexa[g] + hexa[b]
		complementColor = "#" + hexa[ hexa.length - r - 1] + hexa[ hexa.length - g - 1] + hexa[ hexa.length - b - 1]
		
		updateColor()
	}

	function updateColor()
	{
		let tam = 5
		let movR = 0
		let movG = g - Math.trunc(tam/2)
		let movB = b - Math.trunc(tam/2)
		collection = []
		for(let i=0; i<tam+3; i++) //rows
		{
			movR = r - Math.trunc(tam/2)
			for(let j=0; j<tam; j++) //columns
			{	
				collection.push( "#" + hexa[movR] + hexa[movG] + hexa[movB] )
				movR++
			}
			if(i % 2 === 0)
				movG++
					else
				movB++
		}
		collection.splice(0, tam)
		collection = collection
	}

	updateColor()
	
</script>

<main>
	<nav>
		<section>
			<fieldset>
				<legend>Color Control</legend>

				<div id="rngBox">
					<input type="range" id="red" min="0" max="15" bind:value={r} on:input={rangeChange}>
					<input type="range" id="green" min="0" max="15" bind:value={g} on:input={rangeChange}>
					<input type="range" id="blue" min="0" max="15" bind:value={b} on:input={rangeChange}>
				</div>
			</fieldset>
		</section>

		<section id="panel">
			<fieldset>
				<legend>Color Information</legend>
				<div class="panelColor" style="background: {selectedColor}">
					<span>{selectedColor}</span>
				</div>
				<div class="panelColor" style="background: {complementColor}">
					<span>{complementColor}</span>
					<p>Complement Color</p>
				</div>
			</fieldset>
		</section>
	</nav>
	<div id="container">
		{#each collection as color}
			<div class="item-container" style={"background-color:"+color} on:click={()=> changeColor(color) }>
				{#if !color.match(/undefined/g) }
					<span>{color}</span>
				{/if}
			</div>
		{/each}
	</div>
</main>

<style>
	main{
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;

		width: 99vw;
		height: 99vh;
	}
	
	nav{
		width: 20%;
		color: #eee;

		display: flex;
		flex-direction: column;
	}

	#container{
		margin-left: 5%;
		width: 70%;
		height: 90vh;

		display: grid;
		grid-template-columns: repeat(5, 1fr);
		grid-template-rows: auto;
		grid-gap: 0px;

		border-radius: 10px;
		overflow: hidden;
		box-shadow: 0px 0px 3px #555;
	}

	section fieldset{
		margin: 10px;
		padding: 10px;
		border: none;
		box-shadow: 0px 0px 3px #555;
	}
	
	#rngBox{
		transform: rotate(-90deg);
		width: fit-content;
		max-width: 100%;

		margin: 0 auto;

		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		
		padding: 10px;
	}

	#rngBox input{
		height: 25px;
		appearance: none;
		border-radius: 10px;
		margin: 10px 0px; 
	}
	#red{
		background: linear-gradient(90deg, #000, #F00)
	}
	#green{
		background: linear-gradient(90deg, #000, #0F0)
	}
	#blue{
		background: linear-gradient(90deg, #000, #00F)
	}

	#rngBox input::-moz-range-thumb{
		-webkit-appearance: none;
		appearance: none;
		width: 15px;
		height: 15px;
		border-radius: 50%;
		border: 1px solid #eee;
		background-color: #777; 
	} 
	#rngBox input::-webkit-slider-thumb {
		-webkit-appearance: none;
		appearance: none;
		width: 15px;
		height: 15px;
		border-radius: 50%;
		border: 1px solid #eee;
		background-color: #777; 
	}

	
	.panelColor{
		width:15vw;
		height: 15vw;

		margin: 10px auto;
		display: block;
		border-radius: 5px;
	}
	.panelColor:nth-child(3){
		width: 8vw;
		height: 8vw;
		
	}

	.panelColor:nth-child(3) > p{
		background-color: #000;
		opacity: 0;
		border-radius: 5px;
		text-align: center;
		margin: 10px;
	}

	.panelColor:nth-child(3):hover > p{
		opacity: 0.5;
	}

	.panelColor > span{
		
		text-shadow: 0px 0px 3px #222;
		background-color: #222;
		color: #eee;
		border-radius: 5px;
		padding: 5px;
		opacity: 0.5;
		display: inline-block;
		margin: 5px;
	}

	.item-container{
		margin: 0;
		width: 100%;
		height: 100%;
		margin: 0 auto;
		display: flex;
		justify-content: center;
		align-items: center;
		
	}
	.item-container:hover > span{
		opacity: 0.5;
	}

	.item-container span{
		width: fit-content;
		text-shadow: 0px 0px 3px #222;
		background-color: #222;
		color: #eee;
		border-radius: 10px;
		padding: 5px;
		opacity: 0;
		transition: opacity 0.5s;
	}

	@media (max-width:900px)
	{
		main{
			flex-direction: column;
		}

		nav{
			width: 100%;
			flex-direction: row;
		}
		#container{
			margin: 0px;
			width: 100%;
			height: 60%;
		}

		
		section fieldset{
			padding: 0px;
		}

		.panelColor{
			width: 30vw;
		}
		
		.panelColor:nth-child(3){
			width: 15vw;
			height: 15vw;
		}

		#red::after{
			content: "";
			width: 10px;
			height: 10px;
			background-color: #F00;
			position: absolute;
			right: 0;
			border-radius: 50%;
			transform: rotate(90deg);
		}
		#green::after{
			content: "";
			width: 10px;
			height: 10px;
			background-color: #0F0;
			position: absolute;
			right: 0;
			border-radius: 50%;
			transform: rotate(90deg);
		}
		#blue::after{
			content: "";
			width: 10px;
			height: 10px;
			background-color: #00F;
			position: absolute;
			right: 0;
			border-radius: 50%;
			transform: rotate(90deg);
		}
	}


</style>
